import {
  STORE_MESSAGE,
  STORE_MESSAGE_SUCCESS,
  STORE_MESSAGE_FAIL,
  STORE_MESSAGE_RESET,
} from '../actions/storeMessageAction';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
};

const storeMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_MESSAGE:
      return {
        ...state,
        apiState: 'loading',
      };
    case STORE_MESSAGE_SUCCESS:
      return {
        ...state,
        apiState: 'success',
        data: action.response.data,
        message: action.response.message || 'success',
      };
    case STORE_MESSAGE_FAIL:
      return {
        ...state,
        apiState: 'error',
        error: action.response.errors || null,
        message: action.response.message || 'error',
      };
    case STORE_MESSAGE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default storeMessageReducer; 